import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalSustainabilityComponent } from '@app/shared/components/modals/modal-sustainability/modal-sustainability.component';

@Component({
  selector: 'vc-catalog-sustainable',
  templateUrl: './catalog-sustainable.component.html',
  styleUrls: ['./catalog-sustainable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogSustainableComponent implements OnInit {
  @Input()
  public isMobile: boolean;

  @Input()
  public type: 'localCountries' | 'dsEligibleCountries';

  @Input()
  public localFilterName: boolean;

  @Output()
  openSustainableModal = new EventEmitter<boolean>();

  public isDirectShipping: boolean;
  public isExpressDelivery: boolean;
  public isLocalFilter = false;
  public sustainablePanelOpen = false;

  constructor(private dialogService: MatDialog) {}

  ngOnInit(): void {
    this.isDirectShipping = this.type === 'dsEligibleCountries' || false;
    this.isLocalFilter = this.type === 'localCountries' || false;
  }

  openDesktopSustainable() {
    const options = {
      width: '600px',
      data: {
        localFilterName: this.localFilterName
      }
    };
    this.dialogService.open(ModalSustainabilityComponent, options);
  }

  openMobileSustainable() {
    this.sustainablePanelOpen = !this.sustainablePanelOpen;
  }
}
